import ReadalMark from "../ReadalMark"
export function Footer () {
    return (
        <footer>
            <div className="container">
            <div className="footer-top">
                <div className="footer-brand">
                <a href="/" className="logo-mark">
                    <ReadalMark size={34} className="logo-icon" /> READAL SYSTEMS
                </a>
                <p>AI automation, ERP, and cloud infrastructure for companies built to move fast.</p>
                </div>
                <div className="footer-col">
                <h5>Company</h5>
                <a href="#why">Why Readal</a>
                <a href="#process">Process</a>
                <a href="#testimonials">Testimonials</a>
                </div>
                <div className="footer-col">
                <h5>Services</h5>
                <a href="#services">AI Solutions</a>
                <a href="#services">ERP &amp; Odoo</a>
                <a href="#services">Cloud &amp; DevOps</a>
                </div>
                <div className="footer-col">
                <h5>Connect</h5>
                <a href="mailto:admin@readalsystems.com">admin@readalsystems.com</a>
                <a target="_blank" href="https://www.linkedin.com/company/readal-systems/">LinkedIn</a>
                <a target="_blank" href="https://www.instagram.com/readalsystems/">Instagram</a>
                </div>
            </div>
            <div className="footer-bottom">
                <span>© 2026 Readal Systems. All rights reserved.</span>
                <span className="mono">BUILT WITH PRECISION</span>
            </div>
            </div>
        </footer>
    )
}